import { useMemo, useState } from "react";
import {
    X,
    Search,
    Folder,
    Pin,
    Star,
    CheckCircle2,
    FolderSearch
} from "lucide-react";
export default function MediaListSelectorDialog({

    open,

    mode = "move",

    lists = [],

    selected = [],

    loading = false,

    onSubmit,

    onClose

}) {

    const [

        search,

        setSearch

    ] = useState("");

    const [

        selectedList,

        setSelectedList

    ] = useState(null);

    const filteredLists =
        useMemo(

            () => {

                if (!search.trim()) {

                    return lists;

                }

                return lists.filter(

                    list =>

                        list.name
                            .toLowerCase()
                            .includes(
                                search.toLowerCase()
                            )

                );

            },

            [

                lists,

                search

            ]

        );

    if (!open) {

        return null;

    }

    return (

        <div className="ml-dialog-overlay">

            <div className="ml-dialog">

               <div className="ml-header">

    <div>

        <h2>

            {{
                move:"Move Media",
                copy:"Copy Media",
                add:"Add Media to List"
            }[mode]}

        </h2>

        <p>

            Select a destination list.

        </p>

    </div>

    <button
        className="ml-close"
        onClick={onClose}
    >

        <X size={18}/>

    </button>

</div>

               <div className="ml-search-wrapper">

    <Search size={18}/>

    <input

        className="ml-search"

        placeholder="Search lists..."

        value={search}

        onChange={e=>setSearch(e.target.value)}

    />

</div>
                <div className="ml-list-container">

                    {

                        filteredLists.length

                            ?

                            filteredLists.map(

                                list => (

                                    <div

    key={list.id}

    className={`ml-card ${
        selectedList===list.id
            ? "active"
            : ""
    }`}

    onClick={()=>setSelectedList(list.id)}

>

    <div className="ml-left">

        <div className="ml-icon">

            {

                list.pinned

                    ? <Pin size={16}/>

                    : list.favorite

                    ? <Star size={16}/>

                    : <Folder size={16}/>

            }

        </div>

        <div>

            <div className="ml-title">

                {list.name}

            </div>

            {

                list.description &&

                <div className="ml-description">

                    {list.description}

                </div>

            }

        </div>

    </div>

    <div className="ml-right">

        <span className="ml-count">

            {list.totalFiles || 0}

        </span>

        {

            selectedList===list.id &&

            <CheckCircle2
                size={20}
                className="ml-check"
            />

        }

    </div>

</div>

                                )

                            )

                            :

                           <div className="ml-empty">

    <FolderSearch
        size={54}
        strokeWidth={1.5}
    />

    <h3>

        No matching lists

    </h3>

    <p>

        Try another search keyword.

    </p>

</div>

                    }

                </div>

                <div className="ml-footer">

                    <button

                        className="ml-btn"

                        onClick={onClose}

                    >

                        Cancel

                    </button>

                    <button

                        className="ml-btn ml-primary"

                        disabled={

                            !selectedList ||

                            loading

                        }

                        onClick={() =>

                            onSubmit?.({

                                listId:

                                    selectedList,

                                mediaIds:

                                    selected

                            })

                        }

                    >

                        {

                            loading

                                ?

                                "Please wait..."

                                :

                                {

                                    move: "Move",

                                    copy: "Copy",

                                    add: "Add"

                                }[mode]

                        }

                    </button>

                </div>

            </div>

<style>{`

.ml-dialog-overlay{

    position:fixed;

    inset:0;

    background:rgba(0,0,0,.35);

    display:flex;

    justify-content:center;

    align-items:center;

    z-index:99999;

}

.ml-dialog{

    width:560px;

    max-height:80vh;

    display:flex;

    flex-direction:column;

    background:#FFF;

    border-radius:14px;

    overflow:hidden;

    box-shadow:0 25px 60px rgba(0,0,0,.25);

}

.ml-header{

    padding:20px;

    font-size:20px;

    font-weight:700;

}

.ml-search{

    margin:0 20px;

    height:44px;

    border:1px solid #D7DCE3;

    border-radius:10px;

    padding:0 14px;

    font-size:14px;

}

.ml-list-container{

    padding:20px;

    overflow:auto;

    flex:1;

}

.ml-card{

    display:flex;

    justify-content:space-between;

    align-items:center;

    padding:14px;

    border-radius:10px;

    border:1px solid transparent;

    cursor:pointer;

    transition:.2s;

    margin-bottom:10px;

}

.ml-card:hover{

    background:#F8FAFC;

}

.ml-card.active{

    background:rgba(144,202,249,.15);

    border-color:rgba(144,202,249,1);

}

.ml-left{

    display:flex;

    gap:12px;

    align-items:center;

}

.ml-title{

    font-weight:600;

}

.ml-description{

    font-size:12px;

    color:#64748B;

    margin-top:3px;

}

.ml-count{

    color:#64748B;

    font-size:13px;

    font-weight:600;

}

.ml-empty{

    display:flex;

    flex-direction:column;

    align-items:center;

    justify-content:center;

    gap:10px;

    color:#64748B;

    height:180px;

}

.ml-footer{

    display:flex;

    justify-content:flex-end;

    gap:12px;

    padding:18px 20px;

    border-top:1px solid #E5E7EB;

}

.ml-btn{

    border:none;

    height:40px;

    padding:0 20px;

    border-radius:8px;

    cursor:pointer;

}

.ml-primary{

    background:rgba(144,202,249,1);

    color:#FFF;

}

.ml-primary:disabled{

    opacity:.5;

    cursor:not-allowed;

}
    .ml-dialog{

    width:600px;

    max-height:82vh;

    border-radius:18px;

    overflow:hidden;

    background:#FFF;

    box-shadow:
        0 30px 70px rgba(15,23,42,.22);

}

.ml-header{

    display:flex;

    justify-content:space-between;

    align-items:flex-start;

    padding:24px;

    border-bottom:1px solid #EEF2F7;

}

.ml-header h2{

    margin:0;

    font-size:22px;

}

.ml-header p{

    margin-top:6px;

    color:#64748B;

}

.ml-close{

    width:38px;

    height:38px;

    border:none;

    border-radius:10px;

    background:#F8FAFC;

    cursor:pointer;

}

.ml-search-wrapper{

    display:flex;

    align-items:center;

    gap:10px;

    margin:20px;

    padding:0 14px;

    border:1px solid #E2E8F0;

    border-radius:12px;

}

.ml-search{

    flex:1;

    border:none;

    outline:none;

    height:46px;

    background:none;

}

.ml-card{

    display:flex;

    justify-content:space-between;

    align-items:center;

    padding:14px 16px;

    border-radius:14px;

    cursor:pointer;

    transition:.18s;

    border:1px solid transparent;

}

.ml-card:hover{

    background:#F8FAFC;

}

.ml-card.active{

    border-color:#2563EB;

    background:#EFF6FF;

}

.ml-left{

    display:flex;

    align-items:center;

    gap:14px;

}

.ml-icon{

    width:42px;

    height:42px;

    border-radius:12px;

    background:#EFF6FF;

    display:flex;

    justify-content:center;

    align-items:center;

    color:#2563EB;

}

.ml-right{

    display:flex;

    align-items:center;

    gap:12px;

}

.ml-count{

    background:#F1F5F9;

    padding:4px 10px;

    border-radius:999px;

    font-size:12px;

    font-weight:600;

}

.ml-check{

    color:#2563EB;

}

.ml-empty{

    height:220px;

    display:flex;

    flex-direction:column;

    justify-content:center;

    align-items:center;

    color:#64748B;

}

.ml-empty svg{

    color:#94A3B8;

    margin-bottom:14px;

}

`}</style>

        </div>

    );

}